var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 156,
    viewBox: "0 0 208 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.898 59.9779C168.147 39.6628 152.142 27.2906 128.575 21.0294C106.434 15.1615 79.4042 15.9325 58.3754 25.5053C48.8583 29.8497 40.3839 36.1674 33.5194 44.0353C26.0106 52.656 20.5194 63.181 18.8502 74.4924C17.181 85.8039 19.4742 97.7777 26.0886 107.092C32.8486 116.608 43.5398 122.771 54.725 126.191C73.2318 131.883 92.3158 130.201 111.025 134.47C124.441 137.528 138.32 140.007 151.918 137.885C165.516 135.764 178.958 128.266 184.912 115.92C188.448 108.598 189.114 100.272 189.483 92.153C189.753 86.2903 189.889 80.3086 188.282 74.658C186.789 69.3852 183.825 64.6402 180.898 59.9779Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.069 43.502H56.6181C54.5848 43.502 52.9365 45.1422 52.9365 47.1655V87.2731C52.9365 89.2965 54.5848 90.9367 56.6181 90.9367H126.069C128.103 90.9367 129.751 89.2965 129.751 87.2731V47.1655C129.751 45.1422 128.103 43.502 126.069 43.502Z",
    fill: "#00A0F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.0515 57.3945H61.5887C60.0608 57.3945 58.8223 58.627 58.8223 60.1474V67.0346C58.8223 68.555 60.0608 69.7875 61.5887 69.7875H75.0515C76.5793 69.7875 77.8179 68.555 77.8179 67.0346V60.1474C77.8179 58.627 76.5793 57.3945 75.0515 57.3945Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M110.645 68.7381C113.5 68.7381 115.814 66.4353 115.814 63.5946C115.814 60.754 113.5 58.4512 110.645 58.4512C107.791 58.4512 105.477 60.754 105.477 63.5946C105.477 66.4353 107.791 68.7381 110.645 68.7381Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.684 68.7381C121.539 68.7381 123.853 66.4353 123.853 63.5946C123.853 60.754 121.539 58.4512 118.684 58.4512C115.83 58.4512 113.516 60.754 113.516 63.5946C113.516 66.4353 115.83 68.7381 118.684 68.7381Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.2211 78.5742H58.8223V82.2481H73.2211V78.5742Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M90.1 78.5742H75.7012V82.2481H90.1V78.5742Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.98 78.5742H92.5811V82.2481H106.98V78.5742Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.859 78.5742H109.46V82.2481H123.859V78.5742Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.294 53.8867H68.8427C66.8094 53.8867 65.1611 55.5269 65.1611 57.5503V97.6579C65.1611 99.6812 66.8094 101.321 68.8427 101.321H138.294C140.327 101.321 141.976 99.6812 141.976 97.6579V57.5503C141.976 55.5269 140.327 53.8867 138.294 53.8867Z",
    fill: "#FFCC66"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M87.2819 67.7793H73.8191C72.2913 67.7793 71.0527 69.0118 71.0527 70.5321V77.4194C71.0527 78.9398 72.2913 80.1722 73.8191 80.1722H87.2819C88.8098 80.1722 90.0483 78.9398 90.0483 77.4194V70.5321C90.0483 69.0118 88.8098 67.7793 87.2819 67.7793Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M122.876 79.117C125.73 79.117 128.045 76.8142 128.045 73.9735C128.045 71.1329 125.73 68.8301 122.876 68.8301C120.021 68.8301 117.707 71.1329 117.707 73.9735C117.707 76.8142 120.021 79.117 122.876 79.117Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M130.915 79.117C133.77 79.117 136.084 76.8142 136.084 73.9735C136.084 71.1329 133.77 68.8301 130.915 68.8301C128.06 68.8301 125.746 71.1329 125.746 73.9735C125.746 76.8142 128.06 79.117 130.915 79.117Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M85.4515 88.9551H71.0527V92.629H85.4515V88.9551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M102.33 88.9551H87.9316V92.629H102.33V88.9551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M119.21 88.9551H104.812V92.629H119.21V88.9551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M136.084 88.9551H121.686V92.629H136.084V88.9551Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.156 45.1426V86.5076H86.7988V45.1426L88.494 48.5112L90.1944 45.1426L91.8896 48.5112L93.59 45.1426L95.2904 48.5112L96.9856 45.1426L98.686 48.5112L100.381 45.1426L102.082 48.5112L103.777 45.1426L105.477 48.5112L107.172 45.1426L108.873 48.5112L110.573 45.1426L112.268 48.5112L113.969 45.1426L115.664 48.5112L117.364 45.1426L119.06 48.5112L120.76 45.1426L122.455 48.5112L124.156 45.1426Z",
    fill: "#F4F4F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.04 51.0293H90.9639V51.7848H102.04V51.0293Z",
    fill: "#E6E6E6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.985 51.0293H109.907V51.7848H119.985V51.0293Z",
    fill: "#E6E6E6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4483 54.7246H90.9639V55.4801H97.4483V54.7246Z",
    fill: "#E6E6E6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.985 54.7246H109.907V55.4801H119.985V54.7246Z",
    fill: "#E6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.99 58.4258H110.484V59.1813H119.99V58.4258Z",
    fill: "#E6E6E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2527 58.4258H90.9639V59.1813H99.2527V58.4258Z",
    fill: "#E6E6E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.724 62.125H90.9639V62.8805H100.724V62.125Z",
    fill: "#E6E6E6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M119.99 62.125H110.157V62.8805H119.99V62.125Z",
    fill: "#E6E6E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1987 65.8242H90.9639V66.5797H97.1987V65.8242Z",
    fill: "#E6E6E6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M119.99 65.8242H110.484V66.5797H119.99V65.8242Z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M119.99 69.5195H90.9639V70.275H119.99V69.5195Z",
    fill: "#E6E6E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M119.99 73.2188H106.876V73.9742H119.99V73.2188Z",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M151.383 65.0645H81.9316C79.8983 65.0645 78.25 66.7047 78.25 68.728V108.836C78.25 110.859 79.8983 112.499 81.9316 112.499H151.383C153.416 112.499 155.064 110.859 155.064 108.836V68.728C155.064 66.7047 153.416 65.0645 151.383 65.0645Z",
    fill: "#003353"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M100.371 78.957H86.908C85.3802 78.957 84.1416 80.1895 84.1416 81.7099V88.5971C84.1416 90.1175 85.3802 91.35 86.908 91.35H100.371C101.899 91.35 103.137 90.1175 103.137 88.5971V81.7099C103.137 80.1895 101.899 78.957 100.371 78.957Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M135.965 90.2947C138.819 90.2947 141.133 87.9919 141.133 85.1513C141.133 82.3106 138.819 80.0078 135.965 80.0078C133.11 80.0078 130.796 82.3106 130.796 85.1513C130.796 87.9919 133.11 90.2947 135.965 90.2947Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M144.004 90.2947C146.858 90.2947 149.173 87.9919 149.173 85.1513C149.173 82.3106 146.858 80.0078 144.004 80.0078C141.149 80.0078 138.835 82.3106 138.835 85.1513C138.835 87.9919 141.149 90.2947 144.004 90.2947Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M98.5404 100.137H84.1416V103.811H98.5404V100.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M115.419 100.137H101.021V103.811H115.419V100.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M132.299 100.137H117.9V103.811H132.299V100.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M149.178 100.137H134.779V103.811H149.178V100.137Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreCards);
export default __webpack_public_path__ + "static/media/MoreCards.6153e077e3ef68e60d4ed7c60584088f.svg";
export { ForwardRef as ReactComponent };